/* eslint-disable */

const EDUCATION_SIP = {
    "hdfcmcog-gr": 10,
    "relsegp-gr": 25,
    "cmfcgp-gr": 30,
    "edatgp-gr": 10,
    "pp001rg-gr": 25,
}



const WEDDING_SIP = {
    'edutrg-gr': 0, // 10 Edelweiss US Technology Equity Fund of Fund
    'edmarg-gr': 20, // Edelweiss Multi Asset Allocation Fund-Reg(G)
    'rmfgdgp-gr': 10, // Nippon India Gold Savings Fund(G)
    'pp001rg-gr': 20, // Parag Parikh Flexi Cap Fund-Reg(G)
    earg: 20, // Nippon India Large Cap Fund
    dfg: 20, // ICICI Pru Value Discovery Fund(G)
}



const SIF_SIX_PLUS_SIP = {
    "quslsgp-gr": 100,
}

const SIX_PLUS_SIP = {
    "hdfcmcog-gr": 10,
    "hdacgpg-gr": 10,
    "cmfcgp-gr": 25,
    "pp001rg-gr": 15,
    "qumogp-gr": 25,
    "dynmic": 15,
}


const ONE_THREE_SIP = {
    'km35-gr': 50, // Kotak Equity Savings
    'pp001rg-gr': 50, // Parag Parikh Flexi Cap Fund
}

const ONE_YR_SIP = {
    'edmarg-gr': 50,
    'relmtf-gr': 50,
}

const EMERGENCY_SIP = { 'edatgp-gr': 100 }

const COMMODITIES_SIP = {
    'edgfrg-gr': 100,
}

const ANYTIME_SIP = {
    'rmfgdgp-gr': 30, // Nippon Gold Fund
    'km35-gr': 70, // Kotak Equity Savings
}

// 12

const THREE_SIX_SIP = {
    // 'edatgp-gr': 20, // Edelweiss Multi Asset Allocation Fund-Reg(G)
    // 'pp001rg-gr': 25, // Parag Parikh Flexi Cap Fund-Reg(G)
    // 'cmfcgp-gr': 30,
    // 'relsegp-gr': 25, // Nippon India Large Cap Fund
    "hdfcmcog-gr": 10,
    "relsegp-gr": 25,
    "cmfcgp-gr": 30,
    "edatgp-gr": 10,
    "pp001rg-gr": 25,
}


const ARBITRAGE_SIP = {
    'edatgp-gr': 100,
}

const LIQUID_SIP = {
    'rellftpi-gr': 100,
}


const CM_SIP = {
    'cmfcgp-gr': 100,
}
//16
const ONE_TAX_EFFICIENT_SIP = {
    'edatgp-gr': 50,
    'rmfaf-gr': 50,
}

const US_TECH_SIP = {
    'icici1950-gr': 100,
}

const CHINA_EQUITY_SIP = {
    'edgcgp-gr': 100,
}

const SIP_QUANT_SIP = {
    'quslsgp-gr': 100,
}

const AGGRESSIVE_4K_SIP = {
    'cmfcgp-gr': 25,
    'pp001rg-gr': 25,
    'qumogp-gr': 25,
    'dynmic': 25,
}

const AGGRESSIVE_2K_SIP = {
    'cmfcgp-gr': 50,
    'qumogp-gr': 50,
}

const GLOBAL_10YR_SIP = {
    'edgcgp-gr': 50,
    'edutrg-gr': 50,
}

const ALTIVA_SIF_SIP = {
    'eishlrg-gr': 100,
}

const INFINITY_SIF = {
    'kisils1-gr': 100,
}

const SIX_PLUS_RETIREMENT_AGGRESSIVE_SIP = {
    '02': 15,
    'id340-gr': 15,
    'cmfcgp-gr': 20,
    'qumogp-gr': 25,
    'edmsrg-gr': 10,
    'dynmic': 15,
}

const THREE_SIX_AGGRESSIVE_SIP = {
    '02': 20,
    'cmfcgp-gr': 25,
    'edatgp-gr': 10,
    'qumogp-gr': 15,
    'edmsrg-gr': 10,
    'dynmic': 20,

}

const ONE_THREE_AGGRESSIVE_SIP = {
    'km35-gr': 50,
    'edbarg-gr': 50,
}

export const BASKET_IDS = {
    1: SIX_PLUS_SIP, // 1
    2: EDUCATION_SIP, // 2
    3: WEDDING_SIP, // 3
    4: ONE_THREE_SIP, // 4
    5: ONE_YR_SIP,
    6: EMERGENCY_SIP, //7
    8: COMMODITIES_SIP, // 8
    10: ANYTIME_SIP, // 10
    13: ARBITRAGE_SIP, // 13
    14: LIQUID_SIP, // 14
    15: CM_SIP, // 15
    16: ONE_TAX_EFFICIENT_SIP, // 16
    17: US_TECH_SIP, // 17
    18: CHINA_EQUITY_SIP, // 18
    19: SIF_SIX_PLUS_SIP, //
    20: AGGRESSIVE_4K_SIP, //20
    21: AGGRESSIVE_2K_SIP, //21
    22: GLOBAL_10YR_SIP, // 22
    23: ALTIVA_SIF_SIP, // 23
    24: INFINITY_SIF, // 24
    25: SIX_PLUS_RETIREMENT_AGGRESSIVE_SIP, // 25
    26: THREE_SIX_AGGRESSIVE_SIP, // 26
    27: ONE_THREE_AGGRESSIVE_SIP, // 27


}




export const ALL_SIPS_PLANS = {
    EDUCATION_SIP,
    EMERGENCY_SIP,
    WEDDING_SIP,
    ALTIVA_SIF_SIP,
    INFINITY_SIF,
    GLOBAL_10YR_SIP,
    AGGRESSIVE_4K_SIP,
    AGGRESSIVE_2K_SIP,
    SIP_QUANT_SIP,
    CHINA_EQUITY_SIP,
    US_TECH_SIP,
    ONE_TAX_EFFICIENT_SIP,
    ONE_THREE_SIP,
    ONE_YR_SIP,
    CM_SIP,
    COMMODITIES_SIP,
    LIQUID_SIP,
    ARBITRAGE_SIP,
    ANYTIME_SIP,
    SIX_PLUS_SIP,
    THREE_SIX_SIP,
    SIF_SIX_PLUS_SIP,
    SIX_PLUS_RETIREMENT_AGGRESSIVE_SIP,
    THREE_SIX_AGGRESSIVE_SIP,
    ONE_THREE_AGGRESSIVE_SIP,
}   